import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import Todos from './Todos';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function MalzemeIhtiyac() {
  const classes = useStyles();
  const { t } = useTranslation('material_requirement');
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="lg">
        <Header />
        <Todos className={classes.todos} />
      </Container>
    </Page>
  );
}

export default MalzemeIhtiyac;
